var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductTrain = function SvgProductTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91045 18.1094C9.06721 17.7399 9.42968 17.5 9.83103 17.5H14.169C14.5704 17.5 14.9328 17.7399 15.0896 18.1094L15.9381 20.1094C16.2178 20.7689 15.7338 21.5 15.0175 21.5H8.98255C8.26623 21.5 7.78221 20.7689 8.06198 20.1094L8.91045 18.1094ZM14.169 18.5H9.83103L9.61895 19H14.3812L14.169 18.5ZM14.8054 20H9.19471L8.98255 20.5L15.0175 20.5L14.8054 20Z",
    fill: "#FF9800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8 3.44771 8.39797 3 8.88889 3H15.1111C15.6021 3 16 3.44771 16 4V5.5H8V4Z",
    fill: "#44B50C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5C4.99999 5.39543 5.89543 4.5 7 4.5H17C18.1046 4.5 19 5.39543 19 6.5V16C19 17.1046 18.1046 18 17 18H7.00003C5.89546 18 5.00003 17.1046 5.00003 16L5 6.5Z",
    fill: "#59CF1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.25C9 15.9404 8.44037 16.5 7.75 16.5C7.05964 16.5 6.5 15.9404 6.5 15.25C6.5 14.5596 7.05964 14 7.75 14C8.44037 14 9 14.5596 9 15.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.25C17.5 15.9404 16.9404 16.5 16.25 16.5C15.5596 16.5 15 15.9404 15 15.25C15 14.5596 15.5596 14 16.25 14C16.9404 14 17.5 14.5596 17.5 15.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.5C6.5 7.22386 6.72386 7 7 7H17C17.2761 7 17.5 7.22386 17.5 7.5V12C17.5 12.2761 17.2761 12.5 17 12.5H7C6.72386 12.5 6.5 12.2761 6.5 12V7.5Z",
    fill: "white"
  })));
};
export default SvgProductTrain;